<template>
    <article-files
        v-if="articleId"
        class="flex-grow-1 mt-3"
        :scope="scope"
        :article-id="articleId" />
</template>


<script>
import schemaMixin from '@/features/schemas/mixins/schemaMixin'
import { get } from '@/features/schemas/services/schemaApi';

export default {
    types: [
        "articleFile"
    ],
    components: {
        articleFiles: () => import("@/features/articles/ArticleFiles.vue")
    },
    mixins: [schemaMixin],

    props: {
        itemId: {
            type: [Number, String],
            default: null
        },
        scope: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            articleId: null
        }
    },
    async mounted() {
        await this.setArticleId();
    },
    methods: {
        async setArticleId() {
            this.articleId = (await get(this.entityKey, this.scope, this.itemId)).articleId;
        }
    }
}
</script>
